const atualizarPerfis = (state, perfis) => {
    state.perfis = perfis;
}

const atualizarPerfil = (state, perfil) => {
    state.perfil = perfil;
}

export default {
    atualizarPerfis,
    atualizarPerfil
}